<template>
  <div>
    <section>
      <v-row class="my-2 ml-4">
        <h1>Manage orders</h1>
      </v-row>

      <v-divider color="#42a5f5"></v-divider>

      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="blue"
        grow
        slider-color="cyan accent-4"
      >
        <v-tab key="0">
          <v-icon class="mr-4">call_received</v-icon>
          Receiving Orders
        </v-tab>
        <v-tab key="1">
          <v-icon class="mr-4">call_made</v-icon>
          Dispatch Orders
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item :key="0">
          <ReceivingOrders></ReceivingOrders>
        </v-tab-item>

        <v-tab-item :key="1">
          <DispatchOrders></DispatchOrders>
        </v-tab-item>
      </v-tabs-items>




    </section>
  </div>
</template>

<script>
    import ReceivingOrders from "./ReceivingOrders";
    import DispatchOrders from "./DispatchOrders";

    export default {
        name: "ManageOrders",
        components: {
            ReceivingOrders,
            DispatchOrders
        },
        data() {
            return {
                tab: 0,
            }
        },
        computed: {

        }
    }
</script>

<style scoped>
  .center {
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/util/Inventory/ManageOrders.vue